module.exports = __webpack_public_path__ + "img/2-01-04-adp-getting-started.c344ef8f.svg";